// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"97":"44b7665c","242":"d219f1f9","456":"de83ddad","550":"61ef0cb2","643":"c344cd97","684":"de2c3573","729":"ac37a1a9","795":"342104f1","861":"ad3f82c4","910":"34f147e2","948":"20ed9e5b"}[chunkId] + ".chunk.js";
};